import store from "../redux/store";
import {conditions} from "./conditions/conditions";
import {ConditionName} from "../interfaces/enums";
import { footerPadding } from "./environment";

export const LiveDelay = 6; // --> Delay between manifest live point and live point of user's view (for better loading and buffering)
export const LiveWindow = 12; // --> distance between live point and cursor to determine live red button

export const videoTag = () => document.getElementById(conditions(ConditionName.isPlayingAd) ? 'ad-player-tag' : 'player-tag') as HTMLVideoElement;
export const multiLiveVideo = () => document.getElementById(`multilive-player`) as HTMLVideoElement;
export const progressBar = () => document.getElementById("time-progress-bar") as any;
export const progressBarWidth = () => store.getState().videoData.videoElementSizeInfo.width - 2 * footerPadding();

export const seenPoll = () => JSON.parse(localStorage.getItem("seen-poll")!);
export const livePoll = () => JSON.parse(localStorage.getItem("live-poll")!);
export const popoverHeader = () => document.getElementById("popover-header");


